import { type FC, useEffect, useRef } from 'react'

type Props = {
  src: string
  alt?: string
  className?: string
}

const ReplayableIcon: FC<Props> = ({ className, src, alt = 'icon' }) => {
  const imgRef = useRef<HTMLImageElement | null>(null)

  useEffect(() => {
    if (imgRef.current) {
      const { src } = imgRef.current
      // This hack forces gif image to replay after mount
      // @ts-expect-error
      imgRef.current.src = null
      imgRef.current.src = src
    }
  }, [])

  return <img ref={imgRef} src={src} className={className} alt={alt} />
}

export default ReplayableIcon
